import type { NClientsList } from '@app/pages/Clients/ClientsList/ClientsList.types';

/**
 * Префикс "CHF_", используемый в рамках сервиса "Клиенты",
 * является аббревиатурой с англ. "Clients Hard Filters"
 */

// Ключи групп фильтров
export const CHF_VISITS_FILTER = 'VisitsFilter';
export const CHF_CLIENTS_FILTER = 'ClientsFilter';

// Ключи для обеих групп фильтров
export const CHF_LAST_DAYS = 'LastDays';
export const CHF_DATE_START: NClientsList.FilterUnitValueKey = 'DateStart';
export const CHF_DATE_END: NClientsList.FilterUnitValueKey = 'DateEnd';

// Ключи для фильтров по визитам
export const CHF_HAS_RECORDS = 'HasRecords' as NClientsList.FilterUnitValueKey;
export const CHF_STATUSES = 'Statuses' as NClientsList.FilterUnitValueKey;
export const CHF_MIN_COUNT_RECORDS =
  'MinCountRecords' as NClientsList.FilterUnitValueKey;
export const CHF_MAX_COUNT_RECORDS =
  'MaxCountRecords' as NClientsList.FilterUnitValueKey;
export const CHF_PERIOD = 'Period' as NClientsList.FilterUnitValueKey;
export const CHF_MIN_SERVICES_COST =
  'MinServicesCost' as NClientsList.FilterUnitValueKey;
export const CHF_MAX_SERVICES_COST =
  'MaxServicesCost' as NClientsList.FilterUnitValueKey;
export const CHF_MIN_AGE = 'MinAge' as NClientsList.FilterUnitValueKey;
export const CHF_MAX_AGE = 'MaxAge' as NClientsList.FilterUnitValueKey;
export const CHF_EMPLOYEE_IDS =
  'EmployeeIds' as NClientsList.FilterUnitValueKey;
export const CHF_SERVICE_IDS = 'ServiceIds' as NClientsList.FilterUnitValueKey;

// Ключи для фильтров по клиентам
export const CHF_SERVICE_CATEGORY_IDS =
  'ServiceCategoryIds' as NClientsList.FilterUnitValueKey;
export const CHF_GENDER = 'Gender' as NClientsList.FilterUnitValueKey;
export const CHF_BIRTHDAY = 'Birthday' as NClientsList.FilterUnitValueKey;
export const CHF_TAG_IDS = 'TagIds' as NClientsList.FilterUnitValueKey;
export const CHF_BALANCE_S = 'BalanceS';
export const CHF_BALANCE_E = 'BalanceE';
export const CHF_VISITS_TAG_IDS = 'TagIds' as NClientsList.FilterUnitValueKey;
